import PropTypes from "prop-types"

export const marinaPropType = {
  name: PropTypes.string.isRequired,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  addressLineOne: PropTypes.string.isRequired,
  addressLineTwo: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string,
  marinaProfileUrl: PropTypes.string.isRequired,
  marinaImageUrl: PropTypes.string,
  displayPhone: PropTypes.string,
  vhf: PropTypes.string,
}

export const salePropType = {
  contactBoatNames: PropTypes.arrayOf(PropTypes.string),
  encodedId: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  settledStatus: PropTypes.string.isRequired,
  marina: PropTypes.shape(marinaPropType).isRequired,
}
